import { Translations } from '@ts-types/Translations'

const globalTranslations: Translations = {
  es: {
    seo_title: 'Contáctanos',
    seo_description:
      'Contáctanos para resolver dudas, recibir asistencia o conocer más sobre wicadu. Elige tu método preferido: teléfono, WhatsApp, mensaje o correo electrónico. Estamos aquí para ayudarte',
    seo_keywords: '',
    page: {
      title: 'CONTACTAR CON WICADU',
      description: 'Opciones de contacto',
      recommended: 'Recomendado',
      other_options: 'Otras Opciones',
      methods: {
        mail: {
          title: 'Envíanos un correo electrónico',
          description: 'Tiempo de espera estimado: entre 24 y 48 horas',
        },
        call: {
          title: 'Llámanos',
          description: 'No disponible en este momento',
        },
        message: {
          title: 'Envíanos un mensaje',
          description: 'No disponible en este momento',
        },
      },
    },
  },
  en: {
    seo_title: 'Contact Us',
    seo_description:
      "Get in touch to ask questions, get support, or learn more about wicadu. Choose your preferred method: phone, WhatsApp, message, or email. We're here to help",
    seo_keywords: '',
    page: {
      title: 'CONTACT WICADU',
      description: 'Contact Options',
      recommended: 'Recommended',
      other_options: 'Other Options',
      methods: {
        mail: {
          title: 'Email Us',
          description: 'Estimated wait: 24-48 hours',
        },
        call: {
          title: 'Call Us',
          description: 'Currently unavailable',
        },
        message: {
          title: 'Message Us',
          description: 'Currently unavailable',
        },
      },
    },
  },
  fr: {
    seo_title: 'Nous contacter',
    seo_description:
      "Contactez-nous pour poser vos questions, obtenir de l'aide ou en savoir plus sur wicadu. Choisissez votre méthode préférée : téléphone, WhatsApp, message ou e-mail. Nous sommes là pour vous aider.",
    seo_keywords: '',
    page: {
      title: 'CONTACTER WICADU',
      description: 'Options de contact',
      recommended: 'Recommandé',
      other_options: 'Autres options',
      methods: {
        mail: {
          title: 'Envoyez-nous un e-mail',
          description: "Délai estimé : 24 à 48 heures",
        },
        call: {
          title: 'Appelez-nous',
          description: 'Actuellement indisponible',
        },
        message: {
          title: 'Envoyez-nous un message',
          description: 'Actuellement indisponible',
        },
      },
    },
  },
  pt: {},
}


export default globalTranslations
